import { useSelector } from 'react-redux'

import { selectTerritory } from '@/features/domain/territory'
import { useCanAddNewOrder, useIsSimulation, useOrdersLimit } from '@/hooks'
import * as orderHelpers from '@/local/server-data/domain/helpers/order'

import type { SingleViewActionsProps } from '../typings'
import { useTexts } from '../useTexts'
import { useController } from './useController'

export function useSingleViewData(props: SingleViewActionsProps) {
  const { order: orderProp, tab } = props
  const {
    data: { orderInArchivedDay, date, extOrderStep },
  } = useController()

  const order = extOrderStep ?? orderProp
  const entryType = order.type === 'd' || order.type === 's' ? 'delivery' : 'pickup'
  const orderStep = order[entryType]
  const canAddNewOrder = useCanAddNewOrder()
  const isSimulation = useIsSimulation()
  const ordersLimit = useOrdersLimit()
  const texts = useTexts()

  const { rescheduleBehavior } = useSelector(selectTerritory)

  const isExecutionEventsTab = tab === 1

  const duplicateDisabledTooltipTitle = texts.duplicateDisabledTooltipTitle(isSimulation)
  const duplicateDisabledTooltipSubtitle = texts.duplicateDisabledTooltipSubtitle(
    isSimulation,
    ordersLimit,
  )

  const canExportExecutionOrder =
    (orderStep && orderHelpers.isOrderStepExecuted(orderStep, rescheduleBehavior)) ||
    order.status === 'notCompleted'

  return {
    order,
    isSimulation,
    canAddNewOrder,
    orderInArchivedDay,
    isExecutionEventsTab,
    canExportExecutionOrder,
    duplicateDisabledTooltipTitle,
    duplicateDisabledTooltipSubtitle,
    date,
  }
}
